export default class RpaWorkflows {
  static PARSE_TRANSACTIONS = "parse-transactions";

  static MATCH_TRANSACTIONS = "match-transactions";

  static SYNC_BANKFEED = "sync-bankfeed";

  static RECONCILE_TRANSACTONS = "reconcile-transactions";

  static REMOVE_AND_REDO_TRANSACTIONS = "remove-and-redo-transactions";
}
